import {
    SET_ORIGINATORID,
    SET_ORIGINATORNAME,
    SET_SEARCHSTRING,
    FETCH_ORIGINATORS_REQUEST,
    FETCH_ORIGINATORS_SUCCESS,
    FETCH_ORIGINATORS_FAILURE,
    CLEANUP,
  } from "./selectOriginatorType";
  
  const initialState = {
    loading: false,
    originatorId: null,
    searchString: "",
    data: [],
    error: "",
  };
  
  const selectOriginatorReducer = (state = initialState, action) => {
    switch (action.type) {
      case CLEANUP: {
        return initialState;
      }
  
      case SET_ORIGINATORID: {
        return {
          ...state,
          originatorId: parseInt(action.originatorId),
        };
      }
  
      case SET_ORIGINATORNAME: {
        return {
          ...state,
          originatorName: action.originatorName,
        };
      }
  
      case SET_SEARCHSTRING: {
        return {
          ...state,
          searchString: action.searchString,
        };
      }
  
      case FETCH_ORIGINATORS_REQUEST: {
        return {
          ...state,
          loading: true,
        };
      }
  
      case FETCH_ORIGINATORS_SUCCESS: {
        return {
          ...state,
          loading: false,
          data: action.payload,
          error: "",
        };
      }
  
      case FETCH_ORIGINATORS_FAILURE: {
        return {
          ...state,
          loading: false,
          data: [],
          error: action.payload,
        };
      }
  
      default:
        return state;
    }
  };
  
  export default selectOriginatorReducer;
  